import styles from '../Button/Button.module.scss';

type ButtonLinkProps = {
  text: string;
  href: string;
  target?: string;
  rel?: string;
  styleType?: 'primary' | 'secondary' | 'secondaryMini' | 'secondaryWide' | 'ghost' | 'text';
  addClass?: string[];
  disabled?: boolean;
  handleClick?: () => void;
};

export const ButtonLink = ({
  text,
  href,
  target,
  rel,
  styleType = 'primary',
  addClass = [],
  disabled,
  handleClick,
}: ButtonLinkProps) => {
  return (
    <a
      className={[styles.button, ...addClass, styleType && styles[`--${styleType}`]].join(' ')}
      href={href}
      onClick={handleClick}
      target={target && target}
      data-disabled={disabled ? 'true' : 'false'}
      rel={rel && rel}
    >
      {text}
    </a>
  );
};
